// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contextMenuView {
  z-index: 1000;
  position: fixed;
  width: fit-content;
  padding: 4px 2px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-radius: 6px;
  background: #282828;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}
.contextMenuItem {
  min-height: 22px;
  border: 0;
  border-radius: 6px;
  background: #282828;
  color: #f5f5f5;
  cursor: pointer;
  text-align: left;
  padding: 0 10px;
  font-size: 12px;
  line-height: 22px;
  white-space: nowrap;
}
.contextMenuItem:hover {
  background: rgba(0, 118, 255, 0.3);
}
.contextMenuItem:active {
  background: rgba(0, 118, 255, 0.3);
}
.contextMenuItem:disabled {
  color: rgba(245, 245, 245, 0.45);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/ContextMenuView/index.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;AACF;AAEA;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAAF;AAGA;EACE,kCAAA;AADF;AAIA;EACE,kCAAA;AAFF;AAKA;EACE,gCAAA;EACA,mBAAA;AAHF","sourcesContent":[".contextMenuView {\n  z-index: 1000;\n  position: fixed;\n  width: fit-content;\n  padding: 4px 2px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  border-radius: 6px;\n  background: #282828;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);\n}\n\n.contextMenuItem {\n  min-height: 22px;\n  border: 0;\n  border-radius: 6px;\n  background:  #282828;\n  color: #f5f5f5;\n  cursor: pointer;\n  text-align: left;\n  padding: 0 10px;\n  font-size: 12px;\n  line-height: 22px;\n  white-space: nowrap;\n}\n\n.contextMenuItem:hover {\n  background: rgba(0, 118, 255, 0.3);\n}\n\n.contextMenuItem:active {\n  background: rgba(0, 118, 255, 0.3);\n}\n\n.contextMenuItem:disabled {\n  color: rgba(245, 245, 245, 0.45);\n  cursor: not-allowed;\n}\n\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
